import { MISSING_FIELDS_ERROR_MESSAGE } from '../components/Requester/utils/_utils'
import { UseRequesterFormValidationProps } from './_props'

export const useRequesterFormValidation = ({ form, setGlobal, clearGlobal }: UseRequesterFormValidationProps) => {
    const triggerForm = async (shouldReset?: boolean) => {
        if (shouldReset) form.reset()
        const ok = await form.trigger()

        if (!ok) {
            setGlobal(MISSING_FIELDS_ERROR_MESSAGE)
        }
        return ok
    }

    return { triggerForm }
}
